namespace $.$$ {

	$mol_style_define( $shm_hitalama_process_monitor_branch, {
		Trigger: {
			flex: {
				grow: 0,
			},
		},
		Content: {
			margin: {
				left: '1rem',
			},
			border: {
				left: {
					style: 'solid',
					width: '1px',
					color: $mol_theme.line,
				},
				top: {
					style: 'solid',
					width: '1px',
					color: $mol_theme.line,
				},
			},
		},
	} )

}
